let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jV9K1")).then(() => parcelRequire('1P8Jx'));